import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bus-info-card list-item" }
const _hoisted_2 = { class: "bus-name" }
const _hoisted_3 = { class: "bus-way-time" }
const _hoisted_4 = { class: "way" }
const _hoisted_5 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.routeInfo?.RouteName?.Zh_tw), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.routeInfo.DepartureStopNameZh) + " - " + _toDisplayString(_ctx.routeInfo.DestinationStopNameZh), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.routeInfo.SubRoutes[0]?.FirstBusTime) + " - " + _toDisplayString(_ctx.routeInfo.SubRoutes[0]?.LastBusTime), 1)
    ])
  ]))
}